export default __webpack_public_path__ + "static/media/java.32872008.png";